import { render, staticRenderFns } from "./AmountPercentInput.vue?vue&type=template&id=2c6a89d7&"
import script from "./AmountPercentInput.vue?vue&type=script&lang=js&"
export * from "./AmountPercentInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports